import {
  faClose,
  faUpRightFromSquare,
} from '@fortawesome/pro-regular-svg-icons';
import {
  Button,
  Divider,
  HStack,
  Icon,
  IconButton,
  Text,
  ThemeProvider,
  VStack,
} from '@nettbureau/vibrant-ui';

import { createRoot } from 'react-dom/client';
import { MarkerDefinition } from './GoogleMap';

export function buildInfowindowContent(
  wrapper: HTMLElement,
  { name, address, postarea, postcode, infoWindow, url }: MarkerDefinition,
  buttonText: string,
) {
  const onClick = () => {
    infoWindow?.close();

    if (url) {
      window.open(url, '_blank');
    }
  };

  createRoot(wrapper).render(
    <ThemeProvider>
      <VStack align="stretch" gap="md">
        <HStack maxWidth="300px" align="center" gap="md">
          <Text css={{fontSize: "17px !important", fontWeight: "500 !important"}}>
            {name}
          </Text>

          <Divider />

          <IconButton
            size="sm"
            icon={faClose}
            onPress={() => infoWindow?.close()}
          />
        </HStack>

        <Text css={{fontSize: "14px !important"}}>{address}</Text>

        {postcode && postarea && (
          <Text css={{fontSize: "14px !important"}}>
            {postcode} {postarea}
          </Text>
        )}

        {url && !decodeURI(window.location.href).includes(url) && (
          <Button
            width="100%"
            size="sm"
            onPress={onClick}
            layout={{ gap: 'md', direction: 'horizontal' }}
          >
            <Text>{buttonText}</Text>
            <Icon icon={faUpRightFromSquare} />
          </Button>
        )}
      </VStack>
    </ThemeProvider>,
  );
}
